import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

export default function BlogsPage() {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [currentPage, setCurrentPage] = useState(() => {
    const savedPage = sessionStorage.getItem('tbido_blog_page');
    return savedPage ? parseInt(savedPage, 10) : 1;
  });
  const [filterYear, setFilterYear] = useState(() => sessionStorage.getItem('tbido_blog_year') || '');
  const [filterMonth, setFilterMonth] = useState(() => sessionStorage.getItem('tbido_blog_month') || '');
  const [expandedYear, setExpandedYear] = useState(() => sessionStorage.getItem('tbido_blog_expanded_year') || null);

  const [maxVisiblePages, setMaxVisiblePages] = useState(5); 
  const ARTICLES_PER_PAGE = 6;

  useEffect(() => {
    sessionStorage.setItem('tbido_blog_page', currentPage);
    sessionStorage.setItem('tbido_blog_year', filterYear);
    sessionStorage.setItem('tbido_blog_month', filterMonth);
    if (expandedYear) {
      sessionStorage.setItem('tbido_blog_expanded_year', expandedYear);
    } else {
      sessionStorage.removeItem('tbido_blog_expanded_year');
    }
  }, [currentPage, filterYear, filterMonth, expandedYear]);

  useEffect(() => {
    if (window.AOS) {
      window.AOS.init({ 
        duration: 800, 
        once: true, 
        easing: 'ease-out-cubic' 
      });
    }

    const handleResize = () => {
      setMaxVisiblePages(window.innerWidth < 640 ? 4 : 9);
    };
    handleResize(); 
    window.addEventListener('resize', handleResize);

    const fetchArticles = async () => {
      try {
        const response = await fetch('https://tbido-website-api.azurewebsites.net/getActiveArticles');
        if (!response.ok) throw new Error('Failed to fetch articles');
        const data = await response.json();
        setArticles(data.articles);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching articles:', error);
        setArticles(getFallbackArticles());
        setLoading(false);
      }
    };
    fetchArticles();

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const getFallbackArticles = () => [
    {
      id: 'scale-ncr-caravan-1',
      articleTitle: 'SCALE NCR Caravan for Startup Muntinlupa',
      articleAuthor: 'Kurt Leinard D. Balbuena',
      articleDate: 'Apr 25, 2025',
      articleImage: 'https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&q=80',
      articleCategory: ['Incubation', 'Startup'],
      excerpt: 'The SCALE NCR Caravan continues to make strides in fostering inclusive innovation across the region.'
    },
    {
      id: 'scale-ncr-caravan-2',
      articleTitle: 'SCALE NCR Caravan for Startup Muntinlupa',
      articleAuthor: 'Kurt Leinard D. Balbuena',
      articleDate: 'Apr 25, 2025',
      articleImage: 'https://images.unsplash.com/photo-1559136555-9303baea8ebd?w=800&q=80',
      articleCategory: ['Incubation', 'Startup'],
      excerpt: 'Innovation and entrepreneurship take center stage at the latest SCALE NCR event.'
    },
    {
      id: 'scale-ncr-caravan-3',
      articleTitle: 'SCALE NCR Caravan for Startup Muntinlupa',
      articleAuthor: 'Kurt Leinard D. Balbuena',
      articleDate: 'Apr 25, 2025',
      articleImage: 'https://images.unsplash.com/photo-1557804506-669a67965ba0?w=800&q=80',
      articleCategory: ['Incubation', 'Startup'],
      excerpt: 'Local entrepreneurs gain access to resources and mentorship opportunities.'
    },
    {
      id: 'scale-ncr-caravan-4',
      articleTitle: 'SCALE NCR Caravan for Startup Muntinlupa',
      articleAuthor: 'Kurt Leinard D. Balbuena',
      articleDate: 'Apr 25, 2025',
      articleImage: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?w=800&q=80',
      articleCategory: ['Incubation', 'Startup'],
      excerpt: 'Bridging the gap between aspiring entrepreneurs and innovation resources.'
    },
    {
      id: 'scale-ncr-caravan-5',
      articleTitle: 'SCALE NCR Caravan for Startup Muntinlupa',
      articleAuthor: 'Kurt Leinard D. Balbuena',
      articleDate: 'Apr 25, 2025',
      articleImage: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&q=80',
      articleCategory: ['Incubation', 'Startup'],
      excerpt: 'Technology and innovation drive solutions for local challenges.'
    },
    {
      id: 'scale-ncr-caravan-6',
      articleTitle: 'SCALE NCR Caravan for Startup Muntinlupa',
      articleAuthor: 'Kurt Leinard D. Balbuena',
      articleDate: 'Apr 25, 2025',
      articleImage: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?w=800&q=80',
      articleCategory: ['Incubation', 'Startup'],
      excerpt: 'Success stories inspire new entrepreneurs to pursue their startup dreams.'
    },
    {
      id: 'scale-ncr-caravan-7',
      articleTitle: 'SCALE NCR Caravan for Startup Muntinlupa',
      articleAuthor: 'Kurt Leinard D. Balbuena',
      articleDate: 'Apr 25, 2025',
      articleImage: 'https://images.unsplash.com/photo-1553028826-f4804a6dba3b?w=800&q=80',
      articleCategory: ['Incubation', 'Startup'],
      excerpt: 'Fostering collaboration between startups, mentors, and investors.'
    },
    {
      id: 'scale-ncr-caravan-8',
      articleTitle: 'SCALE NCR Caravan for Startup Muntinlupa',
      articleAuthor: 'Kurt Leinard D. Balbuena',
      articleDate: 'Apr 25, 2025',
      articleImage: 'https://images.unsplash.com/photo-1551135049-8a33b5883817?w=800&q=80',
      articleCategory: ['Incubation', 'Startup'],
      excerpt: 'Participants gain access to mentorship programs and funding opportunities.'
    },
    {
      _id: 'scale-ncr-caravan-9',
      articleTitle: 'SCALE NCR Caravan for Startup Muntinlupa',
      articleAuthor: 'Kurt Leinard D. Balbuena',
      articleDate: 'Apr 25, 2025',
      articleImage: 'https://images.unsplash.com/photo-1556761175-4b46a572b786?w=800&q=80',
      articleCategory: ['Incubation', 'Startup'],
      excerpt: 'Building sustainable, scalable businesses that compete globally.'
    },
    {
      _id: 'scale-ncr-caravan-10',
      articleTitle: 'SCALE NCR Caravan for Startup Muntinlupa',
      articleAuthor: 'Kurt Leinard D. Balbuena',
      articleDate: 'Apr 25, 2025',
      articleImage: '/images/featuredimage.png',
      articleCategory: ['Incubation', 'Startup'],
      excerpt: 'A region-wide movement empowering hundreds of entrepreneurs.'
    }
  ];

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <p className="text-gray-600">Loading articles...</p>
      </div>
    );
  }

  const featuredArticle = articles[0];
  const allRecentArticles = articles.slice(1);

  const createSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)+/g, '');
  };
  
  const dateTree = {}; 
  allRecentArticles.forEach(a => {
    const d = new Date(a.articleDate);
    if (isNaN(d)) return;
    const y = d.getFullYear().toString();
    const m = d.getMonth().toString();
    
    if (!dateTree[y]) dateTree[y] = new Set();
    dateTree[y].add(m);
  });

  const availableYears = Object.keys(dateTree).sort((a, b) => b - a);
  availableYears.forEach(y => {
    dateTree[y] = Array.from(dateTree[y]).sort((a, b) => b - a);
  });

  let filteredArticles = allRecentArticles;
  if (filterYear !== '') {
    filteredArticles = filteredArticles.filter(a => new Date(a.articleDate).getFullYear().toString() === filterYear);
  }
  if (filterMonth !== '') {
    filteredArticles = filteredArticles.filter(a => new Date(a.articleDate).getMonth().toString() === filterMonth);
  }

  const totalPages = Math.ceil(filteredArticles.length / ARTICLES_PER_PAGE) || 1;
  const safeCurrentPage = Math.min(currentPage, totalPages);
  
  const indexOfLastArticle = safeCurrentPage * ARTICLES_PER_PAGE;
  const indexOfFirstArticle = indexOfLastArticle - ARTICLES_PER_PAGE;
  const currentArticles = filteredArticles.slice(indexOfFirstArticle, indexOfLastArticle);

  const getVisiblePages = () => {
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    let start = Math.max(1, safeCurrentPage - Math.floor(maxVisiblePages / 2));
    let end = start + maxVisiblePages - 1;
    if (end > totalPages) {
      end = totalPages;
      start = Math.max(1, end - maxVisiblePages + 1);
    }
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };
  const visiblePages = getVisiblePages();

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
    const target = document.getElementById('recent-articles-start');
    if (target) {
      window.scrollTo({ top: target.offsetTop - 100, behavior: 'smooth' });
    }
  };

  const handleSidebarYearClick = (year) => {
    if (expandedYear === year) {
      // Collapse
      setExpandedYear(null);
      setFilterYear('');
      setFilterMonth('');
    } else {
      // Expand and Filter
      setExpandedYear(year);
      setFilterYear(year);
      setFilterMonth('');
    }
    setCurrentPage(1);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <section className="relative bg-gradient-to-br from-[#7B1C2E] via-[#5A1420] to-[#1A3A5C] pt-16 sm:pt-20 md:pt-24 pb-[320px] sm:pb-[400px] md:pb-[500px] lg:pb-[600px] overflow-hidden bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: "url('/images/bg-2.png')" }}>
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center" data-aos="fade-up">
            <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold pt-6 sm:pt-8 md:pt-10 text-white mb-2 sm:mb-3">
              Featured <span className="font-normal">Article</span>
            </h1>
            <p className="text-xs sm:text-sm md:text-base text-gray-200 max-w-2xl mx-auto px-4">
              Welcome to the TBIDO Blog - your hub for startup stories, expert insights, 
              innovation trends, and guides to turn ideas into business revolutions!
            </p>
          </div>
        </div>
      </section>

      {featuredArticle && (
        <section className="relative -mt-[280px] sm:-mt-[360px] md:-mt-[450px] lg:-mt-[500px]">
          <div className="max-w-5xl mx-auto px-4 sm:px-6 md:px-8">
            <div className="relative rounded-2xl sm:rounded-3xl overflow-hidden shadow-xl sm:shadow-2xl" data-aos="zoom-in" data-aos-delay="200">
              <div className="relative h-[350px] sm:h-[400px] md:h-[500px] lg:h-[650px]">
                <img
                  src={featuredArticle.articleImage}
                  alt="Featured Article"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/70 to-black/20"></div>
                
                <div className="flex flex-row absolute top-3 sm:top-4 left-3 sm:left-4">
                  {featuredArticle.articleSDG?.map((sdg, index) => (
                    <img 
                      key={index}
                      src={`/images/SDGs/SDG${sdg}.jpg`} 
                      alt="UNDP" 
                      className="h-8 sm:h-10 pr-2 md:h-12 w-auto"
                    />
                  ))}
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-3 sm:p-6 md:p-8">
                  <h2 className="text-base sm:text-xl md:text-2xl lg:text-3xl font-bold text-white mb-1.5 sm:mb-3">
                    {featuredArticle.articleTitle}
                  </h2>
                  <p className="text-[11px] sm:text-sm text-gray-200 mb-2 sm:mb-4 line-clamp-2">
                    {featuredArticle.excerpt || featuredArticle.articleDescription}
                  </p>
                  <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-4">
                    <div className="text-[11px] sm:text-sm text-gray-300">
                      <p className="text-[9px] sm:text-xs text-gray-400 mb-0.5 sm:mb-1">Written by:</p>
                      <p className="font-medium mb-1 sm:mb-2 text-[11px] sm:text-base">{featuredArticle.articleAuthor}</p>
                      <p className="text-[9px] sm:text-xs text-gray-400 mb-0.5 sm:mb-1">Published on:</p>
                      <p className="text-[11px] sm:text-base">{new Date(featuredArticle.articleDate).toLocaleDateString('en-US', {year: 'numeric', month: 'short', day: 'numeric'})}</p>
                    </div>
                    <Link 
                      to={`/blogs/${createSlug(featuredArticle.articleTitle)}-${featuredArticle._id || featuredArticle.id}`}
                      className="bg-white px-3 sm:px-5 md:px-6 py-1.5 sm:py-2 rounded-full font-semibold hover:bg-gray-100 transition text-[11px] sm:text-sm inline-block w-full sm:w-auto text-center"
                    >
                      <span 
                        className="font-normal bg-clip-text text-transparent"
                        style={{
                          backgroundImage: 'linear-gradient(to right, #6D0C22 0%, #0E386B 92%)'
                        }}
                      >
                        Read Full Article
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}

      <section className="py-10 sm:py-12 md:py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-12">
            
            <div className="w-full lg:w-2/3">
              <div id="recent-articles-start" className="mb-6 sm:mb-8 md:mb-10" data-aos="fade-up">
                <h2 className="text-xl sm:text-2xl md:text-3xl font-bold text-gray-900 mb-2 sm:mb-3">
                  Recent Articles
                </h2>
                <p className="text-xs sm:text-sm md:text-base text-gray-600 max-w-2xl">
                  Welcome to the TBIDO Blog - your hub for startup stories, expert insights, 
                  innovation trends, and guides to turn ideas into business revolutions!
                </p>
              </div>

              <div className="block lg:hidden mb-6 bg-white p-4 rounded-xl shadow-md border border-gray-100" data-aos="fade-up">
                <h3 className="text-sm font-bold text-gray-900 mb-3 border-b pb-2">Filter Articles</h3>
                <div className="flex flex-col sm:flex-row gap-3">
                  <div className="flex-1">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Year</label>
                    <select
                      value={filterYear}
                      onChange={(e) => {
                        setFilterYear(e.target.value);
                        setFilterMonth('');
                        setExpandedYear(e.target.value || null);
                        setCurrentPage(1);
                      }}
                      className="w-full bg-gray-50 border border-gray-200 text-gray-700 text-sm font-medium rounded-lg focus:ring-2 focus:ring-[#0E386B] focus:border-[#0E386B] p-2.5 outline-none"
                    >
                      <option value="">All</option>
                      {availableYears.map(y => (
                        <option key={y} value={y}>{y}</option>
                      ))}
                    </select>
                  </div>
                  <div className="flex-1">
                    <label className="block text-[10px] font-bold text-gray-400 uppercase mb-1">Month</label>
                    <select
                      value={filterMonth}
                      onChange={(e) => {
                        setFilterMonth(e.target.value);
                        setCurrentPage(1);
                      }}
                      disabled={!filterYear}
                      className="w-full bg-gray-50 border border-gray-200 text-gray-700 text-sm font-medium rounded-lg focus:ring-2 focus:ring-[#0E386B] focus:border-[#0E386B] p-2.5 outline-none disabled:opacity-50 disabled:cursor-not-allowed"
                    >
                      <option value="">All</option>
                      {filterYear && dateTree[filterYear] && dateTree[filterYear].map(mIdx => (
                        <option key={mIdx} value={mIdx}>
                          {new Date(0, mIdx).toLocaleString('default', { month: 'long' })}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              {currentArticles.length === 0 ? (
                <div className="text-center py-12 bg-white rounded-2xl shadow-sm border border-gray-100" data-aos="fade-up">
                  <div className="text-4xl mb-3">📰</div>
                  <h3 className="text-lg font-bold text-gray-900">No Articles Found</h3>
                  <p className="text-gray-500 text-sm mt-1">There are no articles matching the selected dates.</p>
                  <button 
                    onClick={() => { setFilterYear(''); setFilterMonth(''); setExpandedYear(null); setCurrentPage(1); }}
                    className="mt-4 px-4 py-2 text-sm text-[#0E386B] font-bold border border-[#0E386B] rounded-lg hover:bg-blue-50 transition-colors"
                  >
                    Clear Filters
                  </button>
                </div>
              ) : (
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-5 md:gap-6">
                  {currentArticles.map((article, index) => (
                    <div
                      key={article._id || article.id}
                      className="bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-shadow flex flex-col h-full"
                      data-aos="fade-up"
                      data-aos-delay={100 + (index * 80)}
                    >
                      <div className="relative h-40 sm:h-44 md:h-48 shrink-0">
                        <img
                          src={article.articleImage}
                          alt={article.articleTitle}
                          className="w-full h-full object-cover"
                        />
                        <div className="flex flex-row absolute top-2 sm:top-3 left-2 sm:left-3">
                          {article.articleSDG?.map((sdg, index) => (
                            <img 
                              key={index}
                              src={`/images/SDGs/SDG${sdg}.jpg`} 
                              alt="UNDP" 
                              className="h-6 pr-1 sm:h-7 md:h-8 w-auto"
                            />
                          ))}
                        </div>
                      </div>

                      <div className="p-4 sm:p-5 flex flex-col flex-grow">
                        <h3 className="text-sm sm:text-base font-bold text-gray-900 mb-2 sm:mb-3 line-clamp-2">
                          {article.articleTitle}
                        </h3>
                        
                        <div className="text-xs text-gray-600 mb-3 sm:mb-4 flex-grow">
                          <p className="text-[10px] sm:text-xs text-gray-500 mb-0.5 sm:mb-1">Written by:</p>
                          <p className="font-medium mb-1 sm:mb-2">{article.articleAuthor}</p>
                          <p className="text-[10px] sm:text-xs text-gray-500 mb-0.5 sm:mb-1">Published on:</p>
                          <p>{new Date(article.articleDate).toLocaleDateString('en-US', {year: 'numeric', month: 'short', day: 'numeric'})}</p>
                        </div>

                        <Link 
                          to={`/blogs/${createSlug(article.articleTitle)}-${article._id || article.id}`}
                          className="mt-auto w-full py-1.5 sm:py-2 border-2 border-gray-300 rounded-lg font-medium hover:border-gray-400 hover:bg-gray-50 transition text-xs sm:text-sm block text-center"
                        >
                          <span 
                            className="font-medium bg-clip-text text-transparent"
                            style={{
                              backgroundImage: 'linear-gradient(to right, #6D0C22 0%, #0E386B 92%)'
                            }}
                          >
                            Read Full Article
                          </span>
                        </Link>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {totalPages > 1 && (
                <div className="mt-8 sm:mt-10 flex flex-wrap justify-center items-center gap-2 pb-8" data-aos="fade-up">
                  <button
                    onClick={() => paginate(safeCurrentPage - 1)}
                    disabled={safeCurrentPage === 1}
                    className="px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg font-medium text-xs sm:text-sm transition-colors border border-gray-300 bg-white disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100 text-gray-700 shadow-sm"
                  >
                    Prev
                  </button>

                  <div className="flex space-x-1 sm:space-x-1.5">
                    {visiblePages.map((pageNum) => (
                      <button
                        key={pageNum}
                        onClick={() => paginate(pageNum)}
                        className={`w-8 h-8 sm:w-10 sm:h-10 rounded-lg font-bold text-xs sm:text-sm transition-all flex items-center justify-center ${
                          safeCurrentPage === pageNum 
                            ? 'bg-gradient-to-r from-[#6D0C22] to-[#0E386B] text-white shadow-md border-transparent' 
                            : 'bg-white text-gray-600 border border-gray-300 hover:bg-gray-100 shadow-sm'
                        }`}
                      >
                        {pageNum}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => paginate(safeCurrentPage + 1)}
                    disabled={safeCurrentPage === totalPages}
                    className="px-3 sm:px-4 py-1.5 sm:py-2 rounded-lg font-medium text-xs sm:text-sm transition-colors border border-gray-300 bg-white disabled:opacity-40 disabled:cursor-not-allowed hover:bg-gray-100 text-gray-700 shadow-sm"
                  >
                    Next
                  </button>
                </div>
              )}
            </div>

            <div className="hidden lg:block lg:w-1/3 mt-0">
              <div className="sticky top-8 space-y-6" data-aos="fade-up" data-aos-delay="200">
                
                <div className="bg-white rounded-2xl shadow-md p-5 border border-gray-100 w-full max-w-[340px]">
                  <h3 className="text-lg font-bold text-gray-900 mb-4 border-b pb-3 flex items-center gap-2">
                    <svg className="w-5 h-5 text-[#6D0C22]" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z"></path></svg>
                    Filter
                  </h3>
                  
                  <div className="space-y-2">
                    {availableYears.map(year => (
                      <div key={year}>
                        <button
                          onClick={() => handleSidebarYearClick(year)}
                          className={`w-full text-left font-semibold py-2 px-3 rounded-lg flex justify-between items-center transition-colors ${
                            filterYear === year ? 'bg-blue-50 text-[#0E386B]' : 'text-gray-700 hover:bg-gray-50'
                          }`}
                        >
                          {year}
                          <span className="text-xs">{expandedYear === year ? '▼' : '▶'}</span>
                        </button>
                        
                        {expandedYear === year && (
                          <div className="pl-4 pr-2 py-2 space-y-1 border-l-2 border-blue-100 ml-3 mt-1">
                            <button
                              onClick={() => { setFilterMonth(''); setCurrentPage(1); }}
                              className={`w-full text-left text-sm py-1.5 px-3 rounded-md transition-colors ${
                                filterMonth === '' ? 'font-bold text-white bg-gradient-to-r from-[#6D0C22] to-[#0E386B] shadow-sm' : 'text-gray-600 hover:text-[#0E386B] hover:bg-blue-50'
                              }`}
                            >
                              All of {year}
                            </button>
                            {dateTree[year].map(monthIdx => {
                              const monthName = new Date(0, monthIdx).toLocaleString('default', { month: 'long' });
                              return (
                                <button
                                  key={monthIdx}
                                  onClick={() => { setFilterMonth(monthIdx); setFilterYear(year); setCurrentPage(1); }}
                                  className={`w-full text-left text-sm py-1.5 px-3 rounded-md transition-colors ${
                                    filterMonth === monthIdx ? 'font-bold text-white bg-gradient-to-r from-[#6D0C22] to-[#0E386B] shadow-sm' : 'text-gray-600 hover:text-[#0E386B] hover:bg-blue-50'
                                  }`}
                                >
                                  {monthName}
                                </button>
                              )
                            })}
                          </div>
                        )}
                      </div>
                    ))}
                  </div>

                  {(filterYear !== '' || filterMonth !== '') && (
                    <button
                      onClick={() => { setFilterYear(''); setFilterMonth(''); setExpandedYear(null); setCurrentPage(1); }}
                      className="w-full mt-5 py-2 text-sm font-semibold text-gray-500 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
                    >
                      Clear Filters
                    </button>
                  )}
                </div>

                <div className="bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-md flex justify-center w-full max-w-[340px] min-h-[500px]">
                  <iframe 
                    src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FDOSTPUPPYLONTBI&tabs=timeline&width=340&height=600&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId" 
                    width="100%" 
                    height="600" 
                    style={{ border: 'none', overflow: 'hidden' }} 
                    scrolling="no" 
                    frameBorder="0" 
                    allowFullScreen={true} 
                    allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
                    title="DOST PUP PYLON TBI Facebook Feed"
                  ></iframe>
                </div>

              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
}